import { useState, type ReactNode } from "react";
import {
	AppContext,
	type AppContextType,
	type DetectResult,
	type PlagiarismResult,
} from "./appContext";

interface AppProviderProps {
	children: ReactNode;
}

export const initialPlagiarismResult: PlagiarismResult = {
	score: 0,
	sourceCounts: 0,
	textWordCounts: 0,
	totalPlagiarismWords: 0,
	identicalWordCounts: 0,
	similarWordCounts: 0,
	sources: [],
	indexes: [],
	text: "",
};

export const initialDetectResult: DetectResult = {
	score: 0,
	sentence_scores: [],
	text: "",
	api: 0,
};

export function AppProvider({ children }: AppProviderProps) {
	const [detectResult, setDetectResult] =
		useState<DetectResult>(initialDetectResult);
	const [plagiarismResult, setPlagiarismResult] = useState<PlagiarismResult>(
		initialPlagiarismResult,
	);

	const value: AppContextType = {
		detectResult,
		setDetectResult,
		plagiarismResult,
		setPlagiarismResult,
	};

	return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}
